/* AramCrochet product page FAQ: fills the empty left column (intro, yarn art, help card)
   and puts the pink highlight on the last word of the heading. */
(function () {
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function init() {
    var col = document.querySelector('#MainContent .pc-pd-faq-heading-col');
    if (!col || col.getAttribute('data-ac-faq')) return;
    col.setAttribute('data-ac-faq', '1');

    var h = col.querySelector('.pc-pd-faq-h2');
    if (h && !h.querySelector('.ac-faq-hl')) {
      /* innerText keeps <br> as a newline, so the existing line break survives */
      var txt = (h.innerText || h.textContent).replace(/\s+$/, '');
      var m = txt.match(/^([\s\S]*\S)(\s+)(\S+)$/);
      if (m) {
        h.innerHTML = esc(m[1]).replace(/\n/g, '<br>') + (m[2].indexOf('\n') > -1 ? '<br>' : ' ') +
          '<span class="ac-faq-hl">' + esc(m[3]) + '</span>';
      }
    }

    var box = document.createElement('div');
    box.className = 'ac-faq-extra';
    box.innerHTML =
      '<p class="ac-faq-sub">Quick answers about our patterns, downloads and stitches. Can\'t find yours? We\'re just one message away.</p>' +
      '<div class="ac-faq-art" aria-hidden="true">' +
        '<svg viewBox="0 0 190 170" fill="none">' +
          '<ellipse cx="82" cy="160" rx="58" ry="7" fill="#7A2C47" opacity=".10"/>' +
          '<path class="ac-thread" d="M128 118 C150 136 166 150 186 152" stroke="#D85F88" stroke-width="3" stroke-linecap="round"/>' +
          '<g class="ac-yarn">' +
            '<circle cx="80" cy="92" r="56" fill="#F6CFDC"/>' +
            '<circle cx="80" cy="92" r="56" stroke="#E79AB6" stroke-width="2"/>' +
            '<path d="M30 70 C60 52 104 52 132 74" stroke="#D85F88" stroke-width="3" stroke-linecap="round"/>' +
            '<path d="M26 92 C58 72 106 72 136 96" stroke="#D85F88" stroke-width="3" stroke-linecap="round"/>' +
            '<path d="M32 116 C62 96 104 98 130 120" stroke="#D85F88" stroke-width="3" stroke-linecap="round"/>' +
            '<path d="M54 42 C44 76 48 116 70 146" stroke="#E79AB6" stroke-width="3" stroke-linecap="round"/>' +
            '<path d="M96 38 C112 70 112 112 96 148" stroke="#E79AB6" stroke-width="3" stroke-linecap="round"/>' +
            '<ellipse cx="60" cy="60" rx="14" ry="8" fill="#fff" opacity=".55" transform="rotate(-30 60 60)"/>' +
          '</g>' +
          '<g transform="rotate(-38 150 60)">' +
            '<rect x="146" y="6" width="8" height="110" rx="4" fill="#7A2C47"/>' +
            '<path d="M146 12 C146 2 158 2 158 10" stroke="#7A2C47" stroke-width="4" stroke-linecap="round"/>' +
            '<rect x="143" y="70" width="14" height="30" rx="7" fill="#D85F88"/>' +
          '</g>' +
        '</svg>' +
      '</div>' +
      '<div class="ac-faq-help">' +
        '<p class="ac-faq-help__title">Still have questions?</p>' +
        '<p class="ac-faq-help__text">Stuck on a round or can\'t find your download? Send us a message and a real person will help.</p>' +
        '<div class="ac-faq-help__btns">' +
          '<a class="ac-faq-btn ac-faq-btn--primary" href="/pages/contact">Contact us <svg viewBox="0 0 24 24" fill="none"><path d="M4 12h14m-5-5 5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>' +
          '<a class="ac-faq-btn ac-faq-btn--ghost" href="/pages/faqs">All FAQs</a>' +
        '</div>' +
      '</div>';
    col.appendChild(box);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
